<template>
  <Handle type="target" :position="Position.Left" />
  <Handle id="happy" type="source" :position="Position.Right" />

  <v-card class="pa-4 bg-success" variant="outlined">
    {{ action.buttonLabel }}
  </v-card>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IStepAction } from "../model/flow.types"
  import { Handle, Position } from "@vue-flow/core"

  export default defineComponent({
    components: { Handle },
    props: {
      action: {
        type: Object as PropType<IStepAction>,
        required: true,
      },
    },

    data() {
      return {
        Position,
      }
    },
  })
</script>
